var render = function () {
  var _vm$currentRound, _vm$currentRound$spea, _vm$currentRound$spea2, _vm$currentRound2, _vm$currentRound2$ste, _vm$currentRound2$ste2, _vm$currentRound3, _vm$currentRound3$ste, _vm$currentRound4, _vm$currentRound4$ste, _vm$currentRound4$ste2, _vm$currentRound4$ste3, _vm$currentRound4$ste4, _vm$currentRound5, _vm$currentRound5$ste, _vm$currentRound5$ste2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('aside', [_c('img', {
    attrs: {
      "alt": "Aside image",
      "src": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$spea = _vm$currentRound.speakerImage) === null || _vm$currentRound$spea === void 0 ? void 0 : (_vm$currentRound$spea2 = _vm$currentRound$spea.image) === null || _vm$currentRound$spea2 === void 0 ? void 0 : _vm$currentRound$spea2.src
    }
  })]), _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "bubble",
    style: _vm.quoteBubbleImage
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$ste = _vm$currentRound2.steps) === null || _vm$currentRound2$ste === void 0 ? void 0 : (_vm$currentRound2$ste2 = _vm$currentRound2$ste[0]) === null || _vm$currentRound2$ste2 === void 0 ? void 0 : _vm$currentRound2$ste2.answer,
      "text-step": 0,
      "class-name": _vm.bubbleTextClass
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isNextStep && !!((_vm$currentRound3 = _vm.currentRound) !== null && _vm$currentRound3 !== void 0 && (_vm$currentRound3$ste = _vm$currentRound3.steps) !== null && _vm$currentRound3$ste !== void 0 && _vm$currentRound3$ste[1]),
      expression: "isNextStep && !!currentRound?.steps?.[1]"
    }],
    staticClass: "paragraph"
  }, [_c('img', {
    attrs: {
      "alt": "Main image",
      "src": (_vm$currentRound4 = _vm.currentRound) === null || _vm$currentRound4 === void 0 ? void 0 : (_vm$currentRound4$ste = _vm$currentRound4.steps) === null || _vm$currentRound4$ste === void 0 ? void 0 : (_vm$currentRound4$ste2 = _vm$currentRound4$ste[1]) === null || _vm$currentRound4$ste2 === void 0 ? void 0 : (_vm$currentRound4$ste3 = _vm$currentRound4$ste2.optionalAnswerImage) === null || _vm$currentRound4$ste3 === void 0 ? void 0 : (_vm$currentRound4$ste4 = _vm$currentRound4$ste3.image) === null || _vm$currentRound4$ste4 === void 0 ? void 0 : _vm$currentRound4$ste4.src
    }
  }), _vm.isNextStep ? _c('blinking-cursor-text', {
    attrs: {
      "text": (_vm$currentRound5 = _vm.currentRound) === null || _vm$currentRound5 === void 0 ? void 0 : (_vm$currentRound5$ste = _vm$currentRound5.steps) === null || _vm$currentRound5$ste === void 0 ? void 0 : (_vm$currentRound5$ste2 = _vm$currentRound5$ste[1]) === null || _vm$currentRound5$ste2 === void 0 ? void 0 : _vm$currentRound5$ste2.answer,
      "text-step": 1
    }
  }) : _vm._e()], 1)])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }